import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';
import Arrow from '../../../../images/pcma-curly-arrow-up.svg';
import arrSquiggle from '../../../../images/pcmc-squiggle-arrow.svg';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  flex-direction: ${props =>
    props.className[0] === 'pcma-banner' ? 'column-reverse' : 'column'};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    gap: 1.5rem;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  margin: 40px auto;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 70px auto;
  }

  &.stacked {
    flex-direction: column-reverse;
  }

  &.spotlight {
    row-gap: 0.5rem;
    margin: 1.5rem auto;
  }
`;

export const Img = styled(Image)`
  width: 100%;
  height: 100%;
  max-width: 215px;
  object-fit: contain;
  object-position: center;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  flex: 1 1 auto;

  ${Wrapper}.app-banner-image-right & {
    order: 1;
  }

  ${Wrapper}.simple-image-banner & {
    max-width: unset;
  }

  ${Wrapper}.simple-image-banner.content-left & {
    order: 0;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      order: 1;
    }
  }

  ${Wrapper}.simple-image-banner.content-right & {
    order: 0;
  }

  @media only screen and (min-width: 444px) {
    min-width: 215px;
    ${Wrapper}.digital-banking-banner &,
    ${Wrapper}.app-banner-image-right & {
      margin: auto;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    ${Wrapper}.pcma-banner & {
      max-width: 500px;
      margin: 0 auto;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${Wrapper}.simple-image-banner & {
      max-width: 30rem;
      max-height: 30rem;
    }

    ${Wrapper}.pcma-banner & {
      max-width: 450px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    ${Wrapper}.pcma-banner & {
      max-width: 550px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    max-width: 300px;
    min-width: auto;
    ${Wrapper}.app-banner-image-right & {
      max-width: 360px;
    }
  }

  ${Wrapper}.stacked & {
    max-width: 320px;
    max-height: 205px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      max-width: 600px;
      max-height: 255px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      max-width: 720px;
      max-height: 305px;
    }
  }
`;

export const Content = styled.div`
  max-width: 856px;

  ${Wrapper}.digital-banking-banner & {
    max-width: 586px;
    line-height: 1.29;
  }

  ${Wrapper}.simple-image-banner.content-left & {
    order: 1;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      order: 0;
    }
  }

  ${Wrapper}.simple-image-banner.content-right & {
    order: 1;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 100%;

    ${Wrapper}.app-banner-image-right & {
      max-width: unset;
      width: 50%;
    }

    ${Wrapper}.pcma-banner & {
      &:after {
        content: '';
        display: block;
        background-image: url(${Arrow});
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        position: absolute;

        @media only screen and (min-width: ${themeGet(
            'breakpoints.sm',
          )}) and (mix-width: 810px) {
          height: 15%;
          width: 20%;
          bottom: 12%;
          right: 43%;
          background-color: black;
        }

        @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
          height: 15%;
          width: 20%;
          bottom: 15%;
          right: 43%;
        }

        @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
          height: 15%;
          width: 20%;
          bottom: 22.5%;
          right: 43%;
        }

        @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
          height: 20%;
          width: 22.5%;
          bottom: 25%;
          right: 43%;
        }
      }
    }
  }

  ${Wrapper}.pcmc & {
    max-width: unset;
    width: 100%;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 50%;
    }

    &:after {
      content: '';
      display: block;
      background-image: url(${arrSquiggle});
      transform: rotate(135deg);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      height: 15%;
      width: 20%;
      bottom: 45%;
      right: 0;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        background-image: url(${arrSquiggle});
        transform: unset;
        height: 20%;
        width: 25%;
        bottom: 58.5%;
        right: 35%;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
        height: 30%;
        width: 20%;
        bottom: 55.5%;
        right: 30%;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
        height: 25%;
        width: 20.5%;
        bottom: 57%;
        right: 39%;
      }
    }
  }

  ${Wrapper}.stacked & {
    text-align: center;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  margin: auto;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    align-items: center;
    margin: 0;
  }
`;

export const Title = styled.h2`
  margin-bottom: 1rem;
  text-align: ${({ $headingAlignment }) => $headingAlignment || 'left'};

  &.velvet,
  &.pcmc {
    color: ${themeGet('colors.velvet')};
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 1.5rem;
    &.pcmc {
      font-size: 2.5rem;
      line-height: 130%;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    ${Wrapper}.simple-image-banner & {
      margin-bottom: 1rem;
    }
  }

  ${Wrapper}.spotlight & {
    font-size: 1rem;
    line-height: 150%;
  }
`;

export const BodyCopy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  p {
    font-size: 1rem;
  }

  a {
    margin-bottom: 1.5rem;
    justify-content: center;

    &:last-child {
      margin: 0;
    }
  }

  ${Wrapper}.digital-banking-banner & {
    line-height: 1.33;
  }

  ${Wrapper}.stacked & {
    align-items: center;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    a {
      margin-bottom: 0;

      &:last-child {
        margin: 0;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-start;

    ${Wrapper}.stacked & {
      flex-direction: column;
    }

    p {
      font-size: 1.125rem;
      font-weight: ${themeGet('fontWeights.normal')};
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      letter-spacing: normal;
      margin: 0.25rem;

      &:last-of-type {
        margin: 0.25rem;
      }
    }

    ${Wrapper}.simple-image-banner & {
      p {
        line-height: 1.5rem;
      }
    }
  }
`;
